export default __webpack_public_path__ + "locales/fr/Article.json?hash=e5f477019f4e82ae8660152fe6c72470";